import React from 'react';
import tw, { styled } from 'twin.macro';

import { FullPage, DeactivatedQueryProvider } from '@sopranodesign/pulse-volt';

import { BotProvider } from '../../Providers/index';

const Sticky = styled.div`
  ${tw`sticky top-0`}
  height: calc(100vh - 12rem);
`;

const FullPagePreview = () => (
  <DeactivatedQueryProvider>
    <BotProvider>
      <Sticky>
        <FullPage />
      </Sticky>
    </BotProvider>
  </DeactivatedQueryProvider>
);

export default FullPagePreview;
